export const SHARE_STRING =
  "Hey, I shared a recipe with you on cookeai.com. click here\n\n";

export const GENERATE_INSTRUCTION_PROMPT = ``;
export const Dark_White_mode = "dark:text-white text-black";
